/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useRef, useState } from 'react';
import { InternalOverlay } from 'react-rainbow-components';
import { useOutsideClick, useWindowResize } from '@rainbow-modules/hooks';
import Dollar from 'components/icons/dollar';
import ChevronRight from 'components/icons/chevronRight';
import { MetaAdReferral } from 'data/firestore/globals';
import getAdPreview from './getAdPreview';
import PaidAdCard from './PaidAdCard';
import positionResolver from './positionResolver';
import {
    ChipButton,
    ChipWrap,
    DropDown,
    MessageAdButton,
    MessageAdChevron,
    MessageAdCopy,
    MessageAdIcon,
    MessageAdLabel,
    MessageAdTitle,
    StyledPaidBadge,
} from './styled';

interface PaidAdChipProps {
    label?: string;
    referral: MetaAdReferral;
    variant?: 'badge' | 'link' | 'message';
}

const PaidAdChip = ({
    label = 'Paid',
    referral,
    variant = 'badge',
}: PaidAdChipProps) => {
    const triggerRef = useRef<any>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);

    useOutsideClick(
        dropdownRef,
        (event: MouseEvent) => {
            const target = event.target as Node;
            const trigger = triggerRef.current as HTMLElement | null;
            if (target !== trigger && !trigger?.contains(target)) {
                setOpen(false);
            }
        },
        open,
    );
    useWindowResize(() => setOpen(false), open);

    const toggle = (event: React.MouseEvent) => {
        event.stopPropagation();
        setOpen(!open);
    };

    const { title } = getAdPreview(referral);

    return (
        <>
            <ChipWrap
                ref={triggerRef}
                $fill={variant === 'message'}
                onClick={variant === 'badge' ? toggle : undefined}
            >
                {variant === 'badge' ? (
                    <StyledPaidBadge variant="brand">
                        <Dollar title="Paid" />
                        {label}
                    </StyledPaidBadge>
                ) : null}
                {variant === 'message' ? (
                    <MessageAdButton type="button" onClick={toggle}>
                        <MessageAdIcon>
                            <Dollar title="Paid" />
                        </MessageAdIcon>
                        <MessageAdCopy>
                            <MessageAdLabel>From an ad</MessageAdLabel>
                            {title ? <MessageAdTitle>{title}</MessageAdTitle> : null}
                        </MessageAdCopy>
                        <MessageAdChevron>
                            <ChevronRight title="Open ad" />
                        </MessageAdChevron>
                    </MessageAdButton>
                ) : null}
                {variant === 'link' ? (
                    <ChipButton type="button" onClick={toggle}>
                        {label}
                    </ChipButton>
                ) : null}
            </ChipWrap>
            <InternalOverlay
                isVisible={open}
                triggerElementRef={() => triggerRef}
                positionResolver={positionResolver}
            >
                <DropDown ref={dropdownRef}>
                    <PaidAdCard referral={referral} />
                </DropDown>
            </InternalOverlay>
        </>
    );
};

export default PaidAdChip;
